
import React from "react";
import { Navigate } from "react-router-dom";
import { LS_ACCESS_TOKEN_KEY } from "../core/constants/common";

const AuthRoute = ({ children }) => {
  const accessToken = localStorage.getItem(LS_ACCESS_TOKEN_KEY);
  if (accessToken) {
    return children;
  } else {
    return <Navigate to="/login" />;
  }
}

export default AuthRoute;